export default "/images/673c5fa6d3125dac3abb087e538128b0.png";